import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoMoeda } from '../../../models/projeto-moeda.model';
import { ProjetoMoedaService } from '../../../services/projeto-moeda.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-projeto-moeda-edit',
  templateUrl: './projeto-moeda-edit.component.html',
  styleUrls: ['./projeto-moeda-edit.component.scss'],
})
export class ProjetoMoedaEditComponent
  extends BaseFormComponent<ProjetoMoeda>
  implements OnInit
{
  actionLabel: string = 'Novo';

  constructor(
    private myService: ProjetoMoedaService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
      ]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back(['pre-projeto/admin/projeto-moeda']);
  }

  getDataCreate(): ProjetoMoeda {
    let data: ProjetoMoeda;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProjetoMoeda) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProjetoMoeda) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace([
                'pre-projeto/admin/projeto-moeda/',
                res.id,
              ]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }
}
